export enum LoanStatus {
    PENDING = 'PENDING',
    PROCESSING = 'PROCESSING',
    BOOKED = 'BOOKED',
    ACTIVE = 'ACTIVE',
    SETTLED = 'SETTLED',
    CANCELED = 'CANCELED',
    RENEGOTIATED = 'RENEGOTIATED',
    WRITTEN_OFF = 'WRITTEN_OFF',
}
